export class ccPaymentVM {
  ccNum: string = '';
  realccNum: string = '';
  ccFname: string = '';
  ccLname: string = '';
  ccMonth: string = '';
  ccYear: string = '';
  ccv: string = '';
  ccZip: string = '';
  ccAmount: number = 0;
  authCode: string = '';
  orderId: string = '';
  status: string = '';

}
